import React, { useState } from 'react'
import { Formik, FieldArray } from 'formik';
import { Col, Container, Row, Form, Button, Modal } from 'react-bootstrap';
import styles from './createQuestions.module.scss';
import { CustomTextField } from '../../../../../shared/customTextField';
import { CustomTextArea } from '../../../../../shared/customTextArea';
import { CustomButton } from '../../../../../shared/customButton'
import { addQuestionToOneWayInterviewTemplate } from '../../../../../../services/util/oneWayInterviewTemplates';
import * as Yup from 'yup';

const CreateQuestionModalActiveTemplate = (props) => {


    let [values, setValues] = useState({
        message: '',
        ans_min: '',
    });
    let [modalActionButtonLoading, setModalActionButtonLoading] = useState(false);

    const validationSchema = Yup.object({
        message: Yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').max(300, 'Character length should be less than 300').required('Required'),
        ans_min: Yup.number().required('Required').min(1, 'Maximum answer duration must be within 1 -10 mins').max(10, 'Maximum answer duration must be within 1 -10 mins'),
    });

    return (
        <div>
            <Modal
                show={props.showModal}
                onHide={props.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.handleClose}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>
                    <div className={styles.modalHeaderDiv}>
                        <h2 className={styles.modalHeader}>Add Question</h2>
                    </div>
                    <div className={styles.modalHeader2Div}>
                        <h2 className={styles.modalHeader2}>One Way Interview Configuration</h2>
                    </div>
                    <Col sm={12}>
                        <Formik
                            enableReinitialize
                            validationSchema={validationSchema}
                            onSubmit={(values) => {
                                props.setFieldValue(`questions.${props.next_index}.message`, values.message);
                                props.setFieldValue(`questions.${props.next_index}.ans_min`, values.ans_min);
                                props.handleClose();
                            }}
                            initialValues={{ message: values.message, ans_min: values.ans_min }}
                        >
                            {({
                                values,
                                errors,
                                setFieldValue,
                                handleChange,
                                handleSubmit,
                                submitCount,
                                touched,
                                setValues
                            }) => (
                                <Form noValidate onSubmit={handleSubmit}>
                                    <CustomTextField
                                        label="Maximum Answer Duration"
                                        classLabel="defaultLabel"
                                        controlId="ans_min"
                                        placeholder="Ex: 3 min"
                                        type="number"
                                        value={values.ans_min}
                                        name="ans_min"
                                        classType="defaultTextBox"
                                        handleOnChange={handleChange}
                                        errorMessage={errors.ans_min}
                                        isInvalid={submitCount > 0 && !!errors.ans_min}
                                    />
                                    <div className="d-flex flex-row align-items-end">
                                        <div className={styles.textArea /*90% width*/}>
                                            <CustomTextArea
                                                label="Question"
                                                name="message"
                                                placeholder="Ex: Please tell me about yourself and your educational background in brief."
                                                values={values.message}
                                                errorMessage={errors.message}
                                                handleChange={handleChange}
                                                isInvalid={submitCount > 0 && !!errors.message}
                                                remainingCount={values.message.length}
                                                maxLength={300}
                                            />
                                        </div>
                                        <p className={styles.queMark /*10% width*/}>?</p>
                                    </div>


                                    <div className='d-flex flex-row-reverse'>
                                        <div className={styles.navigateBtnCol}>
                                            {<CustomButton
                                                id="pipeline_name_confirm"
                                                buttonType="submit"
                                                label="Submit"
                                                type="primaryBtn"
                                                disabled={modalActionButtonLoading === true ? true : false}
                                                backicon={
                                                    modalActionButtonLoading === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                                        : ''
                                                }

                                            />}
                                        </div>
                                    </div>

                                </Form>
                            )}
                        </Formik>

                    </Col>
                </Modal.Body>

            </Modal>
        </div>
    )

}
export default CreateQuestionModalActiveTemplate;